import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createPaymentService } from '../../api/paymentApi';

export const createPayment = createAsyncThunk('payment/createPayment', async (data) => {
    const response = await createPaymentService(data);
    return response.data;
});


const paymentSlice = createSlice({
    name: 'payment',
    initialState: {
        status: null,
        msg: '',
        PaymentLoader: false,
        payment: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createPayment.pending, (state) => {
                state.PaymentLoader = true;
            })
            .addCase(createPayment.fulfilled, (state, action) => {
                state.PaymentLoader = false;
                // // console.log(action.payload,'action.payload');
                
                state.payment = action.payload;
            })
            .addCase(createPayment.rejected, (state, action) => {
                state.PaymentLoader = false;
                state.payment = action.payload;
            })
    },
});

export default paymentSlice.reducer;

